import Cookies from 'js-cookie'

export const getParsedCookie = (cookieName: string) => {
  const cookie = Cookies.get()[cookieName]

  return cookie ? new URLSearchParams(decodeURI(cookie)) : null
}
